import productListInformationFragment from '@data/fragments/products/productListInformation'
import gql from 'graphql-tag'

export default gql`
  fragment orderCategory on Category {
    _id
    name
    products {
      _id
      categories {
        _id
        internalName
      }
      modifiers {
        _id
        optional
      }
      ...productListInformation
    }
  }
  ${productListInformationFragment}
`
